import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
// import { SplashScreen } from '@capacitor/splash-screen';
// import { StatusBar } from '@capacitor/status-bar';
// import { FileTransfer, FileUploadOptions, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
// import { FilePath } from '@awesome-cordova-plugins/file-path/ngx';

// import { Zip} from '@ionic-native/zip/ngx';

// import { File } from '@awesome-cordova-plugins/file/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {   Api, User } from '../providers';
import {   PopovercomponentPageModule } from '../app/popovercomponent/popovercomponent.module';
import {   PostpopoverPageModule } from '../app/postpopover/postpopover.module';
import {   IonModalPageModule } from '../app/ion-modal/ion-modal.module';
import {  AlertmodalPageModule } from '../app/alertmodal/alertmodal.module';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {MycurrencyPipe} from '../providers/pipe/pipe.myCurrency';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [AppComponent,MycurrencyPipe],
    imports: [
        FormsModule,
        HttpClientModule,
        BrowserModule,
        IonicModule.forRoot({ swipeBackEnabled: false }),
        AppRoutingModule,
        PopovercomponentPageModule,
        PostpopoverPageModule,
        IonModalPageModule,
        AlertmodalPageModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    ],
    providers: [
        Api,
        User,
        // StatusBar,
        // SplashScreen,
        // FileTransferObject,
        // Zip,
        // File,
        // FilePath,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    ],
    bootstrap: [AppComponent]
})



export class AppModule {}
